import {useIntl} from 'react-intl';

type FormatOptionsType = Intl.NumberFormatOptions;

export function useGlobalize() {
  const intl = useIntl();

  return {
    formatNumber: (value: number, options?: FormatOptionsType) =>
      intl.formatNumber(value, options),

    formatCurrency: (
      value: number | string,
      currency: string,
      options?: FormatOptionsType,
    ) =>
      intl.formatNumber(typeof value === 'string' ? parseFloat(value) : value, {
        style: 'currency',
        currency,
        ...options,
      }),
  };
}
